module.exports = __webpack_public_path__ + "assets/sideArrowIcon.d4335025.svg";